// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import '../../../theme/index.css'
// import 'element-ui/lib/theme-chalk/index.css'
import App from './home.vue'
import i18n from '@/publicResource/utils/i18n'
import router from '@/publicResource/router'

/* IE下提示Promise未定义的解决方法 */
if (!window.Promise) {
  window.Promise = Promise
}
Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  el: '#app',
  i18n,
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/module/home/home.js